module.exports = __webpack_public_path__ + "img/LADY HAT RED.936f3c2.svg";